import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

interface OrbitRingProps {
  radius: number;
  color?: string;
  alpha?: number; // global reveal multiplier 0..1
}

const OrbitRing: React.FC<OrbitRingProps> = ({ radius, color = "#444444", alpha = 1 }) => {
  const meshRef = useRef<THREE.Mesh>(null);

  useFrame((state) => {
    if (meshRef.current) {
      const time = state.clock.getElapsedTime();
      const material = meshRef.current.material as THREE.MeshBasicMaterial;
      // Animate primary ring but respect global alpha multiplier
      material.opacity = (0.2 + Math.sin(time * 3) * 0.1) * alpha;
    }
  });

  return (
    <group visible={alpha > 0.001}>
      {/* Anneau orbital principal */}
      <mesh ref={meshRef} rotation={[Math.PI / 2, 0, 0]}>
        <ringGeometry args={[radius - 0.08, radius + 0.08, 128]} />
        <meshBasicMaterial
          color={color}
          transparent
          opacity={0.25 * alpha}
          side={THREE.DoubleSide}
        />
      </mesh>

      {/* Anneau orbital secondaire pour effet de profondeur */}
      <mesh rotation={[Math.PI / 2, 0, 0]}>
        <ringGeometry args={[radius - 0.02, radius + 0.02, 64]} />
        <meshBasicMaterial
          color={color}
          transparent
          opacity={0.4 * alpha}
          side={THREE.DoubleSide}
        />
      </mesh>

      {/* Points lumineux sur l'orbite */}
      {[...Array(12)].map((_, i) => {
        const angle = (i / 12) * Math.PI * 2;
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;
        return (
          <mesh key={i} position={[x, 0, z]}>
            <sphereGeometry args={[0.15, 8, 8]} />
            <meshBasicMaterial
              color={color}
              transparent
              opacity={0.6 * alpha}
            />
          </mesh>
        );
      })}
    </group>
  );
};

export default OrbitRing;